import { roomActionTypes } from './room.types';
import http from '../../services/http';
import { logOut } from '../user/user.actions';
import { setNotificationCount } from '../notification/notification.actions';

export const selectWaitingRooms = state => state.rooms.waitingRooms;
export const selectInProgressRooms = state => state.rooms.inProgressRooms;
/**
 * Se a lista de salas em andamento já chegou do servidor pelo menos uma vez.
 *
 * `inProgressRooms: []` é ambíguo -- é "ainda não carregou" e também "carregou
 * e não tem nenhuma". Ver o comentário no `INITIAL_STATE` do reducer.
 */
export const selectInProgressLoaded = state => state.rooms.inProgressLoaded;
export const selectHistoryRooms = state => state.rooms.historyRooms;
export const selectCurrentRoomId = state => state.rooms.currentRoomId;
export const selectShowSendingMessage = state => state.rooms.showSendingMessage;
export const selectCurrentRoom = state => state.rooms.currentRoom;
export const selectRoomAlert = state => state.rooms.roomAlert;
export const selectViewedRooms = state => state.rooms.viewedRooms;

const setWaitingRooms = rooms => {
    return {
        type: roomActionTypes.SET_WAITING_ROOMS,
        payload: rooms
    }
};

const setInProgressRooms = rooms => {
    return {
        type: roomActionTypes.SET_NEW_INPROGRESS_ROOMS,
        payload: rooms
    }
};

export const setCurrentRoom = room => {
    return {
        type: roomActionTypes.SET_CURRENT_ROOM,
        payload: room
    }
};

const setHistoryRooms = rooms => {
    return {
        type: roomActionTypes.SET_HISTORY_ROOMS,
        payload: rooms
    }
}

export const setCurrentRoomId = roomId => {
    return {
        type: roomActionTypes.SET_CURRENT_ROOMID,
        payload: roomId
    }
};

// Atualiza as listas de salas após encerrar/atualizar um atendimento. Precisa ser um
// thunk: antes era uma função comum que chamava os thunks SEM dispatch (no-op) e
// retornava undefined, fazendo `dispatch(blockRoom(...))` virar `dispatch(undefined)`
// e estourar "Cannot read properties of undefined (reading 'type')" no routerMiddleware.
const blockRoom = userId => {
    return dispatch => {
        dispatch(getWaitingRooms());
        dispatch(getInProgressRooms(userId));
    };
};

export const setRoomAlert = value => {
    return {
        type: roomActionTypes.SET_ROOM_ALERT,
        payload: value
    }
};

function normalizeRoomList(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.data)) return payload.data;
    return [];
}

export const getWaitingRooms = () => {
    return async dispatch => {
        try {
            const response = await http.get(`/rooms/waiting`);
            dispatch(setWaitingRooms(normalizeRoomList(response.data)));
        } catch (error) {
            handleError(dispatch, error);
        }
    };
};

export const UpdateInProgressRooms = (roomId, userId, userIdActual, invitedUsers, ticketData = {}, options = {}) => {
    return async dispatch => {
        try {
            const updateData = {
                user_id: userId,
                invited_users: invitedUsers || [userIdActual],
                client: ticketData,
                ...options
            };

            await http.put(`/rooms/${roomId}`, updateData);
            dispatch(setRoomAlert(false));
            dispatch(getInProgressRooms(userIdActual));
            dispatch(setCurrentRoomId(roomId));
        } catch (error) {
            handleError(dispatch, error);
        }
    };
};

export const getInProgressRooms = operatorId => {
    return async dispatch => {
        try {
            const response = await http.get(`/rooms/${operatorId}`);
            dispatch(setInProgressRooms(response.data.length ? response.data : []));
        } catch (error) {
            handleError(dispatch, error);
        }
    };
};

export const getAllRooms = () => {
    return async dispatch => {
        try {
            const response = await http.get(`/rooms`);
            dispatch(setInProgressRooms(response.data.length ? response.data : []));
        } catch (error) {
            handleError(dispatch, error);
        }
    };
};

export const finishRoom = (roomId, userId, ticketData) => {
    return async dispatch => {
        try {
            const response = await http.put(`/rooms/${roomId}`, { status: 0, user_id: userId, closed_by: 'operator', client: ticketData });
            dispatch(blockRoom(userId));
            // Item 9: id do ticket gerado no encerramento (local) para abrir/manter a
            // tela do ticket aberta. Mantém o fallback legado do Movidesk.
            return response.data?.closed_ticket_id || response.data?.movidesk_ticket_id || null;
        } catch (error) {
            handleError(dispatch, error);
            return null;
        }
    };
};

// Finaliza um chat que está na fila de espera e não será atendido. Fecha a sala
// (status 0) enviando finalize_waiting=true, para que o backend gere um ticket com
// status Cancelado referente a esse atendimento não realizado.
export const finalizeWaitingRoom = (roomId, userId) => {
    return async dispatch => {
        try {
            await http.put(`/rooms/${roomId}`, { status: 0, user_id: userId, finalize_waiting: true });
            dispatch(getWaitingRooms());
        } catch (error) {
            handleError(dispatch, error);
        }
    };
};

export const sendMessage = (data, userId) => {
    return async dispatch => {
        try {
            await http.post('/messages', data);
            dispatch(getInProgressRooms(userId));
        } catch (error) {
            handleError(dispatch, error);
        }
    }
};

export const getHistoryRooms = (date, userId) => {
    return async dispatch => {
        try {
            const response = await http.post(`/history/rooms`, {
                dateRange: date || "month",
                user_id: userId
            });
            dispatch(setHistoryRooms(response.data));
        } catch (error) {
            handleError(dispatch, error);
        }
    }
}

// Função auxiliar para lidar com erros comuns
function handleError(dispatch, error) {
    if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
        dispatch(logOut());
    } else {
        console.log(error);
    }
}

const setShowSendingMessage = value => {
    return {
        type: roomActionTypes.SET_SHOW_SENDING_MESSAGE,
        payload: value
    }
};

// Essa ação pode ser despachada onde você deseja alterar o valor de showSendingMessage
export const updateShowSendingMessage = (value) => {
    return dispatch => {
        dispatch(setShowSendingMessage(value))
    }
};

export const setViewedRooms = rooms => {
    return {
        type: roomActionTypes.SET_VIEWED_ROOMS,
        payload: rooms
    }
};
